export const enum ErrorParseMethodEnum {
  default = 0,
  numerate = 1,
}

export const enum AclAccessLevelEnum {
  deny = 'deny',
  reportsOnly = 'reportsOnly',
  readOnly = 'readOnly',
  fullAccess = 'fullAccess',
}

export const enum AclRole {
  user = 'user',
  member = 'member',
}

export const enum AclMemberRole {
  memberUser = 'memberUser',
  memberAdmin = 'memberAdmin',
}

export const enum StatusEnum {
  active = 'active',
  inactive = 'inactive',
  archived = 'archived',
}

export const enum OrderDirEnum {
  desc = 'desc',
  asc = 'asc',
}

export const enum MoveDirectionEnum {
  up = 0,
  down = 1,
}

export const enum AppErrorEnum {
  none = '',
  freePlanLimitsExceeded = 'FREE_PLAN_LIMITS_EXCEEDED',
  unpaidInvoices = 'UNPAID_INVOICES',
  dataRetentionTooOldDataRetrieved = 'DATA_RETENTION_TOO_OLD_DATA_RETRIEVED',
  billingPaymentMethodVerificationFailed = 'BILLING_PAYMENT_METHOD_NOT_SET',
}

export const enum FlowHierarchyTypeEnum {
  rule = 'rule',
  path = 'path',
  utility = 'utility',
  landing = 'landing',
  offer = 'offer',
}

export const enum DrillFilterOptionsEnum {
  equals = 'equals',
  not_equals = 'not_equals'
}

export const enum DelimitersEnum {
  drillFilterOptions = '^'
}

export const enum DialogModeEnum {
  create = 'create',
  edit = 'edit',
  duplicate = 'duplicate'
}

export const enum TagsLogicalRelationEnum {
  or = 'or',
  and = 'and'
}

export const enum TextLogicalRelationEnum {
  or = 'or',
  and = 'and'
}

export const enum MarksFilterModeEnum {
  include = 'include',
  exclude = 'exclude'
}
